var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import constants from '../../../config/constants';
import { utility } from '../../../utils';
import FundingLogStatusHistoryPopup from '../fundingLog/FundingLogStatusHistoryPopup';
var useContractStatusHistoryPopup = function () {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState([]), rows = _b[0], setRows = _b[1];
    var _c = React.useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var requestSeqRef = React.useRef(0);
    var openHistory = React.useCallback(function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var requestSeq, history, res, entries, error_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!txAspireOId)
                        return [2];
                    requestSeq = ++requestSeqRef.current;
                    setOpen(true);
                    setRows([]);
                    setIsLoading(true);
                    history = [];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_MAIN_INFO,
                            payLoad: { TxAspireOId: txAspireOId },
                            showLoader: false,
                        })];
                case 2:
                    res = _e.sent();
                    entries = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 ? (_d = (_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.History) === null || _d === void 0 ? void 0 : _d.ContractStatusHistory : [];
                    history = Array.isArray(entries) ? entries : [];
                    return [3, 4];
                case 3:
                    error_1 = _e.sent();
                    utility.alert('Unable to load contract status history.', constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4:
                    if (requestSeq !== requestSeqRef.current)
                        return [2];
                    setRows(history);
                    setIsLoading(false);
                    return [2];
            }
        });
    }); }, []);
    var historyPopup = (React.createElement(FundingLogStatusHistoryPopup, { open: open, onClose: function () { return setOpen(false); }, rows: rows, isLoading: isLoading }));
    return { openHistory: openHistory, historyPopup: historyPopup };
};
export default useContractStatusHistoryPopup;
